import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { formatBusinessDate, formatDateOnly } from "@helpers/date";
import styles from "./DateCell.module.scss";

export const DateCell = memo(
    ({ row }: CellContext<ViewTableFeatures, TransactionListItem, Date>) => (
        <ViewTableCell className={styles.dateCell}>
            {row.original.dateOnly
                ? formatDateOnly(row.original.dateOnly)
                : formatBusinessDate(row.original.date)}
        </ViewTableCell>
    ),
);
DateCell.displayName = "DateCell";
